import _defineProperty from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
var _excluded = ["region"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { Transform, Matrix } from '@pixi/math';
import { ExtensionType, extensions } from '@pixi/extensions';
import { RenderTexture } from './RenderTexture.mjs';
var tempTransform = new Transform();
var GenerateTextureSystem = /*#__PURE__*/function () {
  function GenerateTextureSystem(renderer) {
    _classCallCheck(this, GenerateTextureSystem);
    this.renderer = renderer;
    this._tempMatrix = new Matrix();
  }
  _createClass(GenerateTextureSystem, [{
    key: "generateTexture",
    value: function generateTexture(displayObject, options) {
      var _ref = options || {},
        manualRegion = _ref.region,
        textureOptions = _objectWithoutProperties(_ref, _excluded);
      var region = manualRegion || displayObject.getLocalBounds(null, true);
      if (region.width === 0) region.width = 1;
      if (region.height === 0) region.height = 1;
      var renderTexture = RenderTexture.create(_objectSpread({
        width: region.width,
        height: region.height
      }, textureOptions));
      this._tempMatrix.tx = -region.x;
      this._tempMatrix.ty = -region.y;
      var transform = displayObject.transform;
      displayObject.transform = tempTransform;
      this.renderer.render(displayObject, {
        renderTexture: renderTexture,
        transform: this._tempMatrix,
        skipUpdateTransform: !!displayObject.parent,
        blit: true
      });
      displayObject.transform = transform;
      return renderTexture;
    }
  }, {
    key: "destroy",
    value: function destroy() {}
  }]);
  return GenerateTextureSystem;
}();
GenerateTextureSystem.extension = {
  type: [ExtensionType.RendererSystem, ExtensionType.CanvasRendererSystem],
  name: "textureGenerator"
};
extensions.add(GenerateTextureSystem);
export { GenerateTextureSystem };